export enum EdsValidationMessageType {
  Undefined = 'Undefined',
  Info = 'Info',
  Warning = 'Warning',
  Error = 'Error',
}
